import {types, endpoints} from 'main/tools';
import CompanySignature from 'main/stores/documents/CompanySignature';
import {DomainStore} from 'shared/store';
import {CustomField, CustomFieldGroup} from 'main/stores/custom_fields';

class AnnotatablePdfStore extends DomainStore {
  async load() {
    await this._compose([
      endpoints.COMPANY_SIGNATURES,
      endpoints.CUSTOM_FIELD_GROUPS.ALL
    ]);
  }

  getCompanySignatures() {
    return this._getAll(types.COMPANY_SIGNATURE, CompanySignature);
  }

  getCustomFields() {
    return this._getAll(types.CUSTOM_FIELD, CustomField);
  }

  getCustomFieldGroups() {
    return this._getAll(types.CUSTOM_FIELD_GROUP, CustomFieldGroup);
  }
}

const singleton = new AnnotatablePdfStore();

export default singleton;
